export interface BrandingModel {
  navbar_bg_color: string;
  navbar_border_color: string;
  logo_url: string | null;
  company_name: string;
  show_company_name: boolean;
  page_bg_color: string;
  font_family: string;
  button_bg_color: string;
  button_text_color: string;
  button_border_radius: string;
  expired_page_title: string;
  expired_page_title_color: string;
  expired_page_description: string;
  expired_page_description_color: string;
  expired_page_support_link: string;
  expired_page_support_text: string;
}

const DEFAULT_BRANDING: BrandingModel = {
  navbar_bg_color: "#0B1C34",
  navbar_border_color: "",
  logo_url: null,
  company_name: "SUDONUM",
  show_company_name: true,
  page_bg_color: "#F5F5F5",
  font_family: "Montserrat",
  button_bg_color: "#91D830",
  button_text_color: "#FFFFFF",
  button_border_radius: "rounded",
  expired_page_title: "Oops! your link has expired",
  expired_page_title_color: "#307CD8",
  expired_page_description:
    "This URL has expired, please ask your sales manager for a list of your not responded to leads or wait until tomorrow for a new URL to be sent.",
  expired_page_description_color: "#0B1C34",
  expired_page_support_link: "",
  expired_page_support_text: "",
};

export class UnconfirmedLeadModel {
  agent_whatsapp_number: string;
  unconfirmed_details: {
    count: number;
    missed: number[];
    yesterday: number;
  };
  modified: string;
  branding: BrandingModel;
  chat_intro_logs: {
    reference_id: string;
    modified: string;
    a_party_name: string;
    a_party_number: string;
    property_name: string;
    community: string;
    price: string;
    address: string;
    subtitle: string;
    agent_name: string;
    image_url: string;
    short_code: string;
    message: string;
  }[];

  constructor(init: any = {}) {
    const data = {
      agent_whatsapp_number: "",
      unconfirmed_details: {
        count: 0,
        missed: [],
        yesterday: 0,
      },
      modified: "",
      branding: DEFAULT_BRANDING,
      chat_intro_logs: [],
      ...init,
    };

    this.agent_whatsapp_number = data.agent_whatsapp_number;
    this.unconfirmed_details = data.unconfirmed_details;
    this.modified = data.modified;
    this.branding = { ...DEFAULT_BRANDING, ...data.branding };
    this.chat_intro_logs = data.chat_intro_logs;
  }
}
